import Marionette from 'backbone.marionette';
import PaginationView from 'base/views/page';
import { GroupListView } from 'base/views/contacts';
import DialogService from 'base/dialog_service';
import ContactGroupCollection from 'base/collections/contacts/groups';

import { Filter } from 'forms/filter/model';
import { FilterView } from 'forms/filter/view';

const SuccessView = Marionette.LayoutView.extend({
    template: require('joinos_codes/templates/print_submitted.html'),

    ui: {
        button: '.button'
    },
    triggers: {
        'click @ui.button': 'close'
    },

    templateHelpers(){
        return {
            mode: this.getOption('mode')
        };
    },
    finishedProcessing(){
        this.options['mode'] = 'done';
        this.render();
    }
});

const PrintGroupListView = GroupListView.extend({
    onChildviewAdd(x, child){
        this.trigger('add', child.model);
    }
});

const PrintCodesView = Marionette.LayoutView.extend({
    template: require('joinos_codes/templates/print_modal.html'),
    regions: {
        filter: '.filter-hook',
        main: '.main-hook',
        paginator: '.pagination-hook',
        selected: '.selected-hook'
    },

    ui: {
        buttonAbandon: '.button-abandon',
        buttonGenerate: '.button-generate'
    },

    triggers: {
        'click @ui.buttonAbandon': 'close',
        'click @ui.buttonGenerate': 'generate'
    },

    onGenerate(){
        this.trigger('close');

        let view = new SuccessView({
            mode: 'processing'
        });
        let m = DialogService.show(view);
        view.on('close', () => {
            m.close();
        });

        this.selectedCollection.createJoinosCodeLetters(() => {
            view.finishedProcessing();
        });
    },

    onRender(){
        this.collection = new ContactGroupCollection([], {
            filter: 'all'
        });
        this.collection.fetch();

        this.selectedCollection = new ContactGroupCollection([], {
            filter: 'all'
        });

        let view = new PrintGroupListView({
            collection: this.collection,
            mode: 'add-group'
        });
        view.on('add', (model) => {
            this.selectedCollection.add(model);
        });
        this.showChildView('main', view);

        let filter = new FilterView({
            collection: this.collection,
            model: new Filter()
        });
        this.showChildView('filter', filter);

        let paging = new PaginationView({
            collection: this.collection
        });
        this.showChildView('paginator', paging);

        let selectedView = new PrintGroupListView({
            collection: this.selectedCollection,
            mode: 'remove-group'
        });
        selectedView.on('add', (model) => {
            this.selectedCollection.remove(model);
        });
        this.showChildView('selected', selectedView);
    }
});

export default PrintCodesView;



// WEBPACK FOOTER //
// ./joinos_codes/views/print.js